var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.769 8.587 8.216 15.14a.45.45 0 1 0 .637.636l6.552-6.552a.45.45 0 1 0-.636-.637z",
    fill: "#383634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.868 6.428-3.301-3.301a.464.464 0 0 0-.637 0l-12.598 12.6a.45.45 0 0 0-.116.202l-1.205 4.503a.45.45 0 0 0 .117.435.434.434 0 0 0 .435.116l4.543-1.218a.453.453 0 0 0 .202-.117l8.797-8.8a.45.45 0 1 0-.637-.636l-8.157 8.16-2.675-2.675 9.697-9.7 2.984 2.985a.443.443 0 0 0 .636 0l1.915-1.918a.45.45 0 0 0 0-.636zM7.627 18.96l-3.545.95.95-3.546 2.595 2.596zM18.633 8.026 15.97 5.36l1.28-1.28 2.664 2.665-1.28 1.28z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewEditIcon);
export default __webpack_public_path__ + "static/media/overview_edit_icon.aaf5a855ab99a857008c38dfa70e4fef.svg";
export { ForwardRef as ReactComponent };